import { render, staticRenderFns } from "./DriversTab.vue?vue&type=template&id=4c5c3726"
import script from "./DriversTab.vue?vue&type=script&lang=js"
export * from "./DriversTab.vue?vue&type=script&lang=js"
import style0 from "./DriversTab.vue?vue&type=style&index=0&id=4c5c3726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports